<script setup>
import { AnnStore } from '@/front/stores/ann_store.js'
import {PlayerStore} from '@/front/stores/player_store.js'
import { VideoStore } from '@/front/stores/video_store.js'
const playerStore = PlayerStore()
const videoStore = VideoStore()

import Button from 'primevue/button';
const { t } = useI18n({});
// Have to calcualte aspect ratio to pin layer to actual video

const reloadPage = () => {
  log.info(1,"💟  ErrorLayer reloadPage")
  window.location.reload()
}

</script>

<template>
  <div id="error-layer" class="absolute top-0 left-0 w-full h-full bg-black overflow-y-scroll no-scrollbar flex flex-col justify-center items-center text-white">
    <div><h1 class="text-3xl font-bold"> {{ $t('common.something_went_wrong') }} </h1></div>
    <div class="my-4"><p class="text-xs font-mono"> {{ playerStore.error }} ({{ videoStore.video.token }})</p></div>
    <div> <Button @click.stop="reloadPage"> {{ $t('common.reload') }} </Button> </div>
  </div>
</template>

<style>
</style>
